<template src="./messageInboxDetail.template.html"></template>
<script>
    import * as axios from "axios";
    import moment from "moment-timezone";
    import Fuse from 'fuse.js'
    import tippy from 'tippy.js'
    import Icon from '../../notificationTemplates/components/Icon'
    import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
    import foliomodal from "../../reservations/reservationDetailVue/folioRecalculateConfirmationModal.vue";
    import { v4 as uuidv4 } from 'uuid';
    import {
        Blockquote,
        CodeBlock,
        HardBreak,
        Heading,
        HorizontalRule,
        OrderedList,
        BulletList,
        ListItem,
        TodoItem,
        TodoList,
        Bold,
        Code,
        Italic,
        Link,
        Strike,
        Underline,
        History,
        Mention,
        Placeholder,
        Table,
        TableCell,
        TableHeader,
        TableRow,
        Image
    } from 'tiptap-extensions'
    export default {
        components: {
            EditorContent,
            EditorMenuBar,
            Icon,
            foliomodal
        },
        name: "messageInboxDetail",
        props: ["conversationId", "parentCallback", "unlinkResCallback", "messageFilterType", "updateReplymessage", "reservationId", "lastMessageObject_rq", "phoneNumbers", "roomInfo"],
        data() {
            return {

                messages: [],
                temp: {
                    old_unique_date: null
                },
                formats: {
                    sameDay: '[Today]',
                    nextDay: '[Tomorrow]',
                    nextWeek: 'dddd',
                    lastDay: '[Yesterday]',
                    lastWeek: 'dddd',
                    sameElse: 'DD MMM YYYY'
                },
                guestInfo: {},
                previousConversationId: null,
                previousMessageFilterType: "",
                unreadMessageText: false,
                groupedMessagesList: {},
                messageToSend: "",
                lastMessageObject: {},
                scrollTimer: -1,
                sendSourceOptionsList: [
                    // {
                    //     SourceName: "Airbnb",
                    //     sourceId: 1,
                    // },
                    // {
                    //     SourceName: "Mail",
                    //     sourceId: 2
                    // },
                ],
                selectedSendSource: 1,
                selectedMediumId: 1,
                showTemplateList: false,
                templateList: [],
                selectedTemplate: null,
                templateDetail: {},
                updateMessageToSend: "",
                previousConversationReplyStatus: "",
                editor: null,
                selectedParam: {},
                repliedUsersList: [],
                messageToSendTextvals: "",
                notifications: [],
                messages_notifications_list: [],
                botMessagesList: [],
                sendShowHide: true,
                footerHeightString: null,
                elemHtml: null,
                scheduleBotsList: [],
                scheduleBotMessage: null,
                noofScheduleBotMessages: 0,
                scheduleBotMessageEditable: false,
                isModalVisible: false,
                modalParams: {},
                showBotslist: false,
                imageData: [],
                imageArr: [],
                image: null,
                apiUrl: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":1339" : ""),
                linkReservationToConversationBit: false,
                isDocuSignModalOpen: false,
                guestEmailList: [],
                companyEmailList: [],
                selectedGuestEmails: [],
                docuSignMessageFromModal: null,
                docusignPreviwUrl: null,
                docusignEnvelopeId: null,
                selectedTemplateType: null,
                res_guestProfileId: null,
                res_companyProfileId: null,
                loading: false,
                extractedText: '',
                matchedIntegration: {},
                docuSignLoader: false,
                signersList: [],
                guestNames: {},
                selectedGuests: [],
                selectedDocusignGuests: [],
                guestRoles: {},
                isDocuSignTemplate: false,
                docusignTemplateDetails: {},
                templateTags: {},
                templateSearch: '',  // for template filter in message inbox detail
                docuSignDocumentUuid: '',
                istemplateActive: false,
                subjectLine: '',
                currentStep: 1,
                steps: [
                    { label: 'Recipients' },
                    { label: 'Preview' },
                    { label: 'Send' },
                ],
                isDocusignIframe: false,
                isSendDisable: false,

                isDocusignHref: null,
                setTime: null,
                DocumentCustomTags: {},
                updatedCustomTabArray: [],
                lengthOfCustomTab: null,
                SignatoryRoleCustomTabs: [],

            }
        },

        methods: {
            assginReservationToConversation() {
                let vm = this;
                vm.linkReservationToConversationBit = !vm.linkReservationToConversationBit;
                vm.$emit('linkReservationToConversation', vm.linkReservationToConversationBit, vm.lastMessageObject.MessageId)
            },
            unlinkReservationToConversation(notification) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "AssignreservationtoConversation",
                    params: {
                        ReservationId: notification.ReservationId,//vm.$route.params.reservationId,
                        ConversationId: notification.ConversationId,
                        Unlink: 1,
                        messageId: vm.lastMessageObject.MessageId
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("err in unlinkreservationtoConversation", err);
                            return
                        }
                        if (response) {
                            console.log("unlinkreservationtoConversation", response.recordsets[2]);
                            let messageObj = response.recordsets[2][0]
                            messageObj.replyUsersList = response.recordsets[3] ? response.recordsets[3] : []
                            if (vm.unlinkResCallback) {
                                vm.unlinkResCallback(messageObj);
                            }
                            vm.$router.push("/messageInbox/" + vm.conversationId + "/" + null);
                            vm.GetConversationMessageList(vm.conversationId)
                        }
                    }
                })
            },
            uploadImages(e) {
                let vm = this;
                this.imageArr = [];
                let files = e.target.files || e.dataTransfer.files;
                for (var i = 0; i < files.length; i++) {
                    this.imageArr.push(files[i]);
                }
                if (!files.length) {
                    return;
                } else {
                    this.createImage(files[0]);
                }
            },
            createImage(file) {
                let reader = new FileReader();
                let vm = this;
                reader.onload = e => {
                    vm.image = e.target.result;
                    // vm.imageArr.push(vm.image);
                    console.log("vm.imageArr", vm.imageArr);
                    const formData = new FormData();
                    Array.from(Array(this.imageArr.length).keys()).map(x => {
                        formData.append("photos", this.imageArr[x], this.imageArr[x].name);
                    });
                    console.log(this.apiUrl + "/upload");
                    let url = this.apiUrl + "/upload";
                    let obj = {};
                    obj.ImageUrl = vm.image;
                    obj.ImageId = -1;
                    vm.imageArr.push(obj);
                    // console.log("base64" + vm.propertyImages);
                    axios.post(url, formData).then(data => {
                        console.log(data.data, data.data.length);
                        // vm.imageArr.splice(-1, data.data.length);
                        console.log("vm.imageArr.splice(-1, data.data.length);", vm.imageArr);
                        // vm.imageData.splice(0, vm.imageData.length);
                        for (let img of data.data) {
                            // vm.imageArr.push(apiUrl + '/downloadImage/'+img.imageGuid)
                            let obj = {};
                            obj.ImageUrl = img.imageGuid;
                            obj.ImageId = -1;
                            // vm.imageArr.splice(-1,1);
                            //vm.imageArr.push(obj);
                            vm.imageData.push(obj);
                            // vm.sendReplyMail(img.imageGuid)
                        }
                        localStorage.setItem("MessageInboxImage_" + vm.reservationId, JSON.stringify(vm.imageData));
                        this.sendShowHide = true;
                        this.lastMessageObject.SendEmail = true;
                        this.messageToSendTextvals = true;
                        console.log(vm.imageArr);
                    });
                };
                reader.readAsDataURL(file);
            },
            imageUrls(imageUid) {
                let vm = this
                // alert(imageUid)
                return vm.apiUrl + '/downloadImage/' + imageUid + '/430*300'
            },
            removeImage(img, index) {
                let vm = this;
                vm.imageData.splice(index, 1)
                if (vm.imageData.length > 0) {
                    localStorage.setItem("MessageInboxImage_" + vm.reservationId, JSON.stringify(vm.imageData));
                    this.sendShowHide = true;
                    this.lastMessageObject.SendEmail = true;
                    this.messageToSendTextvals = true;
                } else {
                    localStorage.removeItem("MessageInboxImage_" + vm.reservationId);
                    this.sendShowHide = false;
                    this.lastMessageObject.SendEmail = false;
                    this.messageToSendTextvals = false;
                }
                // if (!vm.imageData.length) {
                vm.$refs.fileupload.value = null;
                // }
            },
            openPopup(messageBody) {
                var vm = this;
                vm.isModalVisible = true;
                vm.modalParams = {
                    popupMessage: messageBody,
                    html: true,
                    footer: false
                };
            },
            closePopup() {
                let vm = this;
                vm.isModalVisible = false;
            },
            updateDate(scheduleBot, dateObj) {
                let vm = this;
                // console.log(key)
                scheduleBot.NotificationDate = dateObj ? dateObj.format("Do MMM YYYY") : null;
            },
            revertEditedScheduleBot(scheduleBot, event) {
                let vm = this;
                vm.isModalVisible = true;
                if (event) {
                    event.preventDefault();
                }
                vm.changedScheduleBot = scheduleBot
                vm.modalParams = {
                    popupTitle: "",
                    popupMessage: "Do you want to discard this draft ?",
                    displayYesNoButtons: true,
                    yesButtontext: "Discard",
                    noButtonText: "Cancel",
                    yesButtonCallback: vm.discradDraftChanges,
                    noButtonCallback: vm.closePopup,
                    // cancelbuttonCallback: vm.closePopup
                    noCloseButton: true
                };
            },
            discradDraftChanges() {
                let vm = this
                vm.changedScheduleBot.NotificationDate = vm.changedScheduleBot.scheduleBotObj.NotificationDate
                vm.changedScheduleBot.NotificationTime = vm.changedScheduleBot.scheduleBotObj.NotificationTime
                console.log("scheduleBot.scheduleBotMessage = ", vm.changedScheduleBot.scheduleBotObj);
                if (this.$el.querySelector(`#message${vm.changedScheduleBot.LogId}${vm.changedScheduleBot.BotSubeventId}`)) {
                    this.$el.querySelector(`#message${vm.changedScheduleBot.LogId}${vm.changedScheduleBot.BotSubeventId}`).innerHTML = vm.changedScheduleBot.scheduleBotObj.scheduleBotMessage
                }
                vm.changedScheduleBot.scheduleBotMessageEditable = false
                vm.changedScheduleBot.showhideCalender = false
                vm.changedScheduleBot.showhidetimepicker = false
                vm.isModalVisible = false;
            },
            editll() {
                alert("hai")
            },
            editScheduleBotMessage(bot, event) {
                let vm = this;
                bot.scheduleBotMessageEditable = true
            },
            get_JobDetails(scheduleBot) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "get_JobDetails",
                    params: {
                        ReservationId: scheduleBot.EventGeneratedId,
                        EventId: scheduleBot.EventId,
                        SubEventId: scheduleBot.BotSubeventId,
                        BotId: scheduleBot.BotId
                    },
                    callback: function (err, response) {
                        if (err) {
                            return;
                        }
                        if (response) {
                            console.log("response in get_JobDetails", response);
                            vm.getLogIdsByEventID(scheduleBot.EventId, scheduleBot.BotSubeventId, scheduleBot.EventGeneratedId)
                        }
                    }
                });
            },
            getLogIdsByEventID(eventId, SubEventId, resId, fromFolder) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_LogDetails_ByEventId",
                    params: {
                        ReservationId: resId,
                        EventId: eventId,
                        SubEventId: SubEventId,
                        fromFolder: fromFolder
                    },
                    callback: function (err, response) {
                        if (err) {
                            return;
                        }
                        if (response) {
                            console.log("response in getLogIdsByEventID", response);
                        }
                    }
                });
            },
            getEditedBotMessage(scheduleBot) {
                scheduleBot.editedval = this.$el.querySelector(`#message${scheduleBot.LogId}${scheduleBot.BotSubeventId}`) ? this.$el.querySelector(`#message${scheduleBot.LogId}${scheduleBot.BotSubeventId}`).innerHTML : scheduleBot.scheduleBotMessage
                console.log(scheduleBot.scheduleBotMessage)
            },
            SaveUpdateBotdetails_Reservation(scheduleBot, sendStatus, event, savechanges, revstatusId) {
                let vm = this;
                scheduleBot.sendstatus = sendStatus
                scheduleBot.statusId = revstatusId
                event.preventDefault();   // throw this in for good measures too
                // e.stopPropigation();
                scheduleBot.scheduleBotMessage = this.$el.querySelector(`#message${scheduleBot.LogId}${scheduleBot.BotSubeventId}`) ? this.$el.querySelector(`#message${scheduleBot.LogId}${scheduleBot.BotSubeventId}`).innerHTML : scheduleBot.scheduleBotMessage
                vm.$store.dispatch("dataRequestHandler", {
                    key: "SaveUpdateBotdetails_Reservation",
                    params: {
                        scheduleBot
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("SaveUpdateBotdetails_Reservation", err);
                            return;
                        }
                        if (response) {
                            console.log("SaveUpdateBotdetails_Reservation = ", response)
                            // if (savechanges == "savechanges") {
                            //     scheduleBot.Edited = 1
                            // }
                            if (scheduleBot.JobIdExists) {
                                vm.get_JobDetails(scheduleBot);
                            }
                            else {
                                if ((vm.lastMessageObject.StatusId == 6 && (scheduleBot.BotSubeventId == 16 || scheduleBot.BotSubeventId == 18)) || (vm.lastMessageObject.StatusId == 7 && scheduleBot.BotSubeventId == 19) || ((vm.lastMessageObject.StatusId == 1 || vm.lastMessageObject.StatusId == 3 || vm.lastMessageObject.StatusId == 5) && scheduleBot.BotSubeventId == 15)) {
                                    vm.getLogIdsByEventID(scheduleBot.EventId, scheduleBot.BotSubeventId, scheduleBot.EventGeneratedId, "fromUpdateFutureRes")
                                }
                                // if (vm.lastMessageObject.StatusId == 7 && scheduleBot.BotSubeventId == 19) {
                                //     vm.getLogIdsByEventID(scheduleBot.EventId, scheduleBot.BotSubeventId, scheduleBot.EventGeneratedId, "fromUpdateFutureRes")
                                // }
                                // if ((vm.lastMessageObject.StatusId == 1 || vm.lastMessageObject.StatusId == 3 || vm.lastMessageObject.StatusId == 5) && scheduleBot.BotSubeventId == 15) {
                                //     vm.getLogIdsByEventID(scheduleBot.EventId, scheduleBot.BotSubeventId, scheduleBot.EventGeneratedId, "fromUpdateFutureRes")
                                // }
                            }
                            scheduleBot.scheduleBotMessageEditable = false
                            scheduleBot.showhideCalender = false
                            scheduleBot.showhidetimepicker = false
                            // scheduleBot.scheduleBotObj = {}
                            if (savechanges && savechanges == "undoBotChanges") {
                                // this.$el.querySelector(`#message${scheduleBot.LogId}${scheduleBot.BotSubeventId}`).innerHTML = scheduleBot.scheduleBotObj.scheduleBotMessage
                                scheduleBot.scheduleBotMessage = scheduleBot.scheduleBotObj.scheduleBotMessage
                                if (!scheduleBot.JobIdExists) {
                                    if ((vm.lastMessageObject.StatusId == 6 && (scheduleBot.BotSubeventId == 16 || scheduleBot.BotSubeventId == 18)) || (vm.lastMessageObject.StatusId == 7 && scheduleBot.BotSubeventId == 19) || ((vm.lastMessageObject.StatusId == 1 || vm.lastMessageObject.StatusId == 3 || vm.lastMessageObject.StatusId == 5) && scheduleBot.BotSubeventId == 15)) {
                                        vm.getLogIdsByEventID(scheduleBot.EventId, scheduleBot.BotSubeventId, scheduleBot.EventGeneratedId)
                                    }
                                    // if (vm.lastMessageObject.StatusId == 7 && scheduleBot.BotSubeventId == 19) {
                                    //     vm.getLogIdsByEventID(scheduleBot.EventId, scheduleBot.BotSubeventId, scheduleBot.EventGeneratedId)
                                    // }
                                    // if ((vm.lastMessageObject.StatusId == 1 || vm.lastMessageObject.StatusId == 3 || vm.lastMessageObject.StatusId == 5) && scheduleBot.BotSubeventId == 15) {
                                    //     vm.getLogIdsByEventID(scheduleBot.EventId, scheduleBot.BotSubeventId, scheduleBot.EventGeneratedId)
                                    // }
                                }
                            }
                            vm.Get_LogDetails_By_ReservationId(scheduleBot)
                        }
                    }
                })
            },
            showcalender(scheduleBot, event) {
                scheduleBot.showhideCalender = !scheduleBot.showhideCalender
                event.stopPropagation();
                event.preventDefault();
            },
            showtimepicker(scheduleBot, event) {
                scheduleBot.showhidetimepicker = !scheduleBot.showhidetimepicker
                event.stopPropagation();
                event.preventDefault();
            },
            getBotDetailsLogId(scheduleBot) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_BotDetails_ByLogId",
                    params: {
                        LogId: scheduleBot.LogId,
                        BotId: scheduleBot.BotId,
                        BotSubeventId: scheduleBot.BotSubeventId
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("Get_BotDetails_ByLogId", err);
                            return;
                        }
                        if (response) {
                            console.log("Get_BotDetails_ByLogId", response)
                            scheduleBot.scheduleBotMessageEditBtn = true
                            scheduleBot.childElementExpandedOrnot = !scheduleBot.childElementExpandedOrnot
                            if (!scheduleBot.childElementExpandedOrnot) {
                                if (scheduleBot.scheduleBotMessageEditable && ((scheduleBot.editedval && scheduleBot.editedval !== scheduleBot.scheduleBotObj.scheduleBotMessage) || (scheduleBot.NotificationDate !== scheduleBot.scheduleBotObj.NotificationDate) || (scheduleBot.NotificationTime !== scheduleBot.scheduleBotObj.NotificationTime))) {
                                    vm.revertEditedScheduleBot(scheduleBot)
                                    return
                                }
                                scheduleBot.scheduleBotMessageEditable = false
                                scheduleBot.showhideCalender = false
                                scheduleBot.showhidetimepicker = false
                            }
                            if (response.recordsets && response.recordsets[0] && response.recordsets[0].length > 0) {
                                let templateDetails = {
                                    HTMLObj: response.recordsets[0][0].HtmlContent,
                                    SubjectLineHTML: null,
                                    CCHTML: null,
                                    FromHTML: null,
                                    ReplyToHTML: null
                                }
                                vm.previewSlectedTemplate("fromScheduleBots", templateDetails, scheduleBot)
                            }
                        }
                    }
                })
            },
            Get_LogDetails_By_ReservationId(scheduleBot) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_LogDetails_By_ReservationId",
                    params: {
                        ReservationId: vm.lastMessageObject.ReservationId
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("Get_LogDetails_By_ReservationId", err);
                            return;
                        }
                        if (response) {
                            console.log("Get_LogDetails_By_ReservationId", response)
                            vm.scheduleBotsList = response[0]
                            for (let bot of vm.scheduleBotsList) {
                                vm.$set(bot, "scheduleBotMessageEditable", false)
                                vm.$set(bot, "scheduleBotMessageEditBtn", false)
                                vm.$set(bot, "scheduleBotMessage", "")
                                vm.$set(bot, "showhideCalender", false)
                                vm.$set(bot, "showhidetimepicker", false)
                                vm.$set(bot, "childElementExpandedOrnot", false)
                                vm.$set(bot, "showEditBtn", false)
                                console.log("scheduleBot === ", scheduleBot)

                                bot.NotificationDate = bot.NotificationDate ? moment.utc(bot.NotificationDate).format("Do MMM YYYY") : bot.NotificationDate
                                bot.NotificationTime = bot.NotificationTime ? moment(bot.NotificationTime, 'h:mmA').format("h:mm A") : bot.NotificationTime
                                vm.$set(bot, "scheduleBotObj", JSON.parse(JSON.stringify(bot)))
                                if (scheduleBot && scheduleBot.BotId == bot.BotId && scheduleBot.BotSubeventId == bot.BotSubeventId && scheduleBot.LogId == bot.LogId) {
                                    bot.scheduleBotMessage = scheduleBot.scheduleBotMessage
                                    bot.childElementExpandedOrnot = scheduleBot.childElementExpandedOrnot
                                    bot.scheduleBotObj = scheduleBot.scheduleBotObj
                                }
                            }
                            vm.noofScheduleBotMessages = response[0] ? response[0].length : 0
                        }
                    }
                })
            },
            showEmailContent(htmlcontent) {
                var win = window.open();
                // "", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,top=" + (screen.height - 400) + ",left=" + (screen.width - 840)
                win.document.body.innerHTML = htmlcontent;
            },
            // groupByDate(date) {
            //     var old_date = this.temp.old_unique_date;
            //     var new_date = new Date(date).getDate();
            //     if (old_date != new_date) {
            //         this.temp.old_unique_date = new_date;
            //         var day = ("0" + new Date(date).getDate()).slice(-2);
            //         var month = ("0" + (new Date(date).getMonth() + 1)).slice(-2);
            //         var date_data = day + "/" + month;
            //         return date_data;
            //     } else {
            //         return "";
            //     }
            // }
            chartCountLength(message) {
                if (message && message.length > 100) {
                    return 'charCount'
                }
                else {
                    return ''
                }
            },
            groupByDate(date) {
                // const year = new Date(date).getFullYear();
                // const day = (`0${new Date(date).getDate()}`).slice(-2);
                // const month = (`0${new Date(date).getMonth() + 1}`).slice(-2);
                // const date_data = `${year}.${month}.${day}`;
                let momentDate = moment(date).format("YYYY MMM DD");
                if (this.old_unique_date === momentDate) {
                    return "";
                }
                this.old_unique_date = momentDate
                let result = '';
                result += `<div class="chat-day-title">`
                result += `<span class="title">`
                result += moment(momentDate).calendar(null, this.formats);
                result += `</span>`
                result += `</div>`
                return result;
                // moment(momentDate).calendar(null, this.formats)
                // console.log("this.old_unique_date = date_data == ",moment(momentDate).calendar(null, this.formats))
                // console.log("this.old_unique_date", this.old_unique_date, "==", date_data, "result", moment().calendar(date, this.formats))
                // result += `<div class="chat-date text-center relative-position">`;
                // result += `<span class="line inline-b"></span>`;
                // result += `<span class="inline-b bg-white txt-13 text-grey-6 pd-5 absolute-center">`;
                // // eslint-disable-next-line no-multi-assign,no-return-assign
                // result += this.old_unique_date = date_data;
                // result += `</span>`;
                // result += `</div>`;
                // eslint-disable-next-line no-multi-assign,no-return-assign
                // return this.old_unique_date = date_data;
            },
            GetConversationMessageList(conversationId) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetConversationMessageList",
                    params: {
                        ConversationId: conversationId ? conversationId : vm.conversationId,
                        ReservationId: vm.reservationId && vm.reservationId != "null" ? vm.reservationId : vm.lastMessageObject.ReservationId ? vm.lastMessageObject.ReservationId : null
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("GetConversationMessageList", err);
                            return;
                        }
                        if (response) {
                            console.log("response in GetConversationMessageList", response);
                            vm.$store.commit("setRefreshMessageNotificationPanel", false);
                            vm.messages.splice(0, vm.messages.length, ...response[1]);
                            vm.notifications.splice(0, vm.notifications.length, ...response[2]);
                            vm.botMessagesList.splice(0, vm.botMessagesList.length, ...response[4]);
                            vm.repliedUsersList.splice(0, vm.repliedUsersList.length, ...response[3])
                            if (vm.notifications.length > 0) {
                                vm.notifications = vm.notifications.map(notifi => {
                                    vm.$set(notifi, "unlinkReservationAndThread", false);
                                    return notifi
                                })
                                let linkNotifi = vm.notifications.filter(notifi => {
                                    // vm.$set(notifi, "unlinkReservationAndThread", false);
                                    console.log(notifi)
                                    if (notifi.SubEventId == 31 || notifi.SubEventId == 32) {
                                        return notifi
                                    }
                                })
                                if (linkNotifi.length > 0) {

                                    const notifiByConversation = linkNotifi.reduce((notifi, value) => {
                                        // Group initialization
                                        if (!notifi[value.ConversationId]) {
                                            notifi[value.ConversationId] = [];
                                        }
                                        // Grouping
                                        notifi[value.ConversationId].push(value);

                                        return notifi;
                                    }, {});

                                    console.log("notifiByConversation = ", Object.values(notifiByConversation).length)
                                    linkNotifi = Object.values(notifiByConversation).map(notifi => {
                                        return notifi[notifi.length - 1]
                                    })
                                    console.log("linkNotifi =", linkNotifi)
                                    linkNotifi.map(notifi => {

                                        let notifiIndex = vm.notifications.indexOf(notifi)
                                        console.log(notifiIndex)
                                        if (notifiIndex > -1) {
                                            vm.notifications[notifiIndex]["unlinkReservationAndThread"] = true
                                        }
                                    })
                                }
                            }
                            vm.notifications = vm.notifications.filter(notif => notif.Messagecontent != null && notif.Messagecontent != "")
                            if (vm.messages.length > 0) {
                                vm.guestInfo = {
                                    guestName: `${vm.messages[0].GuestFirstName} ${vm.messages[0].GuestLastName}`,
                                    guestProfileId: vm.messages[0].GuestProfileId,
                                    noOfStays: vm.messages[0].CountofStays,
                                    initials: vm.messages[0].Initials
                                }
                            }

                            vm.messages_notifications_list = vm.messages.concat(vm.notifications);
                            if (vm.botMessagesList.length > 0) {
                                vm.botMessagesList = vm.botMessagesList.map((message) => {
                                    let messageobject = {
                                        DateCreated: message.UpdatedDate ? message.UpdatedDate : message.CreatedDate ? message.CreatedDate : null,
                                        GuestName: "Bot",
                                        GuestNameInitials: "B",
                                        IsBotMessage: true,
                                        IsGuest: false,
                                        Message: message.EmailContent ? JSON.parse(message.EmailContent).MessageBody : "",
                                        IsMessagesRead: true,
                                        botId: message.BotId,
                                        guestMessageBot: message.Isguest,
                                        ImageURL: message.EmailContent ? JSON.parse(message.EmailContent).imageUrl : "",
                                        SentmessageStatus: message.IswarningExist,
                                        sentMessageErrorText: message.WarningMessage,
                                    }
                                    return messageobject
                                })
                                vm.botMessagesList = vm.botMessagesList.sort(function (a, b) {

                                    return new Date(a.DateCreated) - new Date(b.DateCreated);
                                });
                                console.log("botMessagesList = ", vm.botMessagesList.length)
                                let messageDetailVal = null, botId = null
                                vm.botMessagesList = vm.botMessagesList.filter(msg => {
                                    // if (((msg.guestMessageBot == null && msg.Message !== messageDetailVal) || msg.guestMessageBot == 1) && msg.DateCreated && msg.Message) {
                                    if (msg.DateCreated && msg.Message && ((msg.guestMessageBot == null && msg.Message !== messageDetailVal) || msg.guestMessageBot == 1)) {
                                        console.log(msg.botId, "=", msg.Message)
                                        messageDetailVal = msg.Message;
                                        botId = msg.botId
                                        return msg
                                    }
                                })
                                console.log("botMessagesList = ", vm.botMessagesList.length)
                                vm.messages_notifications_list = vm.messages_notifications_list.concat(vm.botMessagesList)
                            }

                            vm.messages_notifications_list = vm.messages_notifications_list.sort(function (a, b) {

                                return new Date(a.DateCreated) - new Date(b.DateCreated);
                            });
                            // vm.messages_notifications_list.slice().sort((a, b) => new Date(b.DateCreated) - new Date(a.DateCreated))
                            vm.unreadMessageText = false
                            // if ((vm.messageFilterType == "all" || vm.messageFilterType == "notResponded") && vm.previousMessageFilterType != "unread") {
                            if (vm.messageFilterType == "all" || vm.messageFilterType == "notResponded") {
                                vm.UpdateMessageStatus(conversationId);
                            }
                            // else if ((vm.messageFilterType == "all" || vm.messageFilterType == "notResponded") && vm.previousMessageFilterType == "unread") {
                            //     vm.UpdateMessageStatus(vm.previousConversationId);
                            // }
                            else if (vm.messageFilterType == "unread") {
                                vm.UpdateMessageStatus(vm.previousConversationId);
                            }
                            if (vm.messageFilterType == "notResponded" && vm.previousConversationId && vm.previousConversationReplyStatus) {
                                vm.$store.state.bus.$emit("updatePreviousItem", { ConversationId: vm.previousConversationId });
                            }
                            // vm.UpdateMessageStatus(conversationId);
                            let lastGuestName, guestNameKey = "", lastMessageDate;
                            vm.groupedMessagesList = {}
                            let old_date = null
                            vm.messages_notifications_list.forEach((msg, index) => {
                                vm.$set(msg, "showMoreMessage", true);
                                vm.$set(msg, "indexval", index);
                                vm.$set(msg, "contentheight", 0);
                                let momentDate = moment(msg.DateCreated).format("YYYY MMM DD");
                                // moment.locale('yourlang', {
                                //     calendar: {
                                //         lastDay: function () {
                                //             return '[Yesterday]';
                                //         },
                                //         sameDay: function () {
                                //             return '[Today]';
                                //         },
                                //         nextDay: function () {
                                //             return '[Tomorrow]';
                                //         },
                                //         nextWeek: function () {
                                //             return 'dddd';
                                //         },
                                //         lastWeek: function () {
                                //             return 'dddd';
                                //         },
                                //         sameElse: function () {
                                //             return 'DD MMM YYYY';
                                //         }
                                //     }
                                // });
                                let dateText = ""
                                if (old_date != momentDate) {
                                    old_date = momentDate
                                    dateText += `<div class="chat-day-title">`
                                    dateText += `<span class="title">`
                                    dateText += moment(momentDate).calendar(null, vm.formats)
                                    dateText += `</span>`
                                    dateText += `</div>`
                                }
                                vm.$set(msg, "dateText", dateText);
                                let result = ""
                                if (!msg.IsMessagesRead && !vm.unreadMessageText && !msg.NotificationId) {
                                    vm.unreadMessageText = true
                                    result += `<div class="chat-day-title" id="unreadMessageTitle">`
                                    result += `<span class="title">`
                                    result += 'Unread Messages';
                                    result += `</span>`
                                    result += `</div>`
                                }
                                vm.$set(msg, "result", result);

                                let msgDate = moment(msg.DateCreated).format("YYYY-MM-DD")
                                if (msg.GuestName !== lastGuestName) {
                                    guestNameKey = `${msg.GuestName}_${index}`
                                    vm.groupedMessagesList[guestNameKey] = {};
                                    vm.groupedMessagesList[guestNameKey].data = msg
                                    vm.groupedMessagesList[guestNameKey].messages = []

                                    lastGuestName = msg.GuestName;
                                    lastMessageDate = moment(msg.DateCreated).format("YYYY-MM-DD");
                                }
                                else if (msg.GuestName == lastGuestName && !moment(msgDate).isSame(lastMessageDate)) {
                                    guestNameKey = `${msg.GuestName}_${index}`
                                    vm.groupedMessagesList[guestNameKey] = {};
                                    vm.groupedMessagesList[guestNameKey].data = msg
                                    vm.groupedMessagesList[guestNameKey].messages = []

                                    lastGuestName = msg.GuestName;
                                    lastMessageDate = moment(msg.DateCreated).format("YYYY-MM-DD");
                                }
                                // add current message to the current div
                                // if(guestNameKey){
                                vm.groupedMessagesList[guestNameKey].messages.push(msg);
                                // }
                                // }else{
                                //     console.log("${lastGuestName}_${index-1}", `${lastGuestName}_${index-1}`)
                                //     groupedMessagesList[`${lastGuestName}_${index-1}`].messages.push(msg);
                                //     console.log(groupedMessagesList[`${lastGuestName}_${index-1}`])
                                // }
                            });
                            vm.$nextTick(function () {
                                // DOM updated
                                vm.scroll_bottom();
                                vm.getRefs()
                                // var container = $('.guest-chat-body'),
                                //     scrollTo = $('#unreadMessageTitle');
                                // if (scrollTo.length) {
                                //     vm.scroll_bottom();
                                // } else {
                                //     vm.scroll_bottom();
                                // }


                            });


                            vm.GetLastMessageList()

                            // setTimeout(function () {

                            //     var container = $('.guest-chat-body'),
                            //         scrollTo = $('#unreadMessageTitle');
                            //     if (scrollTo.length) {
                            //         container.animate({
                            //             scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop() - 50
                            //         });
                            //     } else {
                            //         $("#chat-body").scrollTop($('#chat-body')[0].scrollHeight);
                            //         $(".guest-chat-body").scrollTop($('.guest-chat-body')[0].scrollHeight);
                            //         // $(".guest-chat-body").stop().animate({ scrollTop: $(".guest-chat-body")[0].scrollHeight}, 1000);
                            //     }
                            // }, 100);
                            // setTimeout(function () {
                            //     const topLabel = document.getElementById('date-label')
                            //     const messageBox = document.getElementById('chat-body')
                            //     messageBox.addEventListener('scroll', () => {
                            //         const dateLabels = document.querySelectorAll('.chat-day-title')
                            //         let currentLabel = null
                            //         dateLabels.forEach((dateLabel) => {
                            //             if (messageBox.scrollTop >= dateLabel.offsetTop) {
                            //                 currentLabel = dateLabel
                            //             }
                            //         })
                            //         if (currentLabel) {
                            //             topLabel.style.opacity = '1'
                            //             topLabel.innerText = currentLabel.innerText
                            //         } else {
                            //             topLabel.style.opacity = '0'
                            //         }
                            //     })
                            // }, 2000);
                        }
                    }
                });
            },
            handelScroll() {
                let vm = this
                const topLabel = document.getElementById('date-label')
                topLabel.style.visibility = "visible"
                const messageBox = $('.guest-chat-body')
                // const messageBox = document.getElementById('messages')
                messageBox.on('scroll', function () {
                    // console.log("messageBox.scrollTop === ", messageBox.scrollTop)
                    // messageBox.addEventListener('scroll', () => {
                    $(".divider").addClass("sticky");
                    const dateLabels = document.querySelectorAll('.messageDates')
                    let currentLabel = null
                    dateLabels.forEach((dateLabel) => {
                        // console.log("dateLabel.innerText === ", dateLabel.innerText)
                        if (messageBox.scrollTop() >= dateLabel.offsetTop - 200 && dateLabel.innerText) {
                            // console.log("messageBox.scrollTop === ", messageBox.scrollTop())
                            // console.log("dateLabel.offsetTop === ", dateLabel.offsetTop)
                            // console.log("dateLabel.innerText === ", dateLabel.innerText)
                            currentLabel = dateLabel
                        }
                    })
                    // console.log("currentLabel === ", currentLabel.innerText)
                    if (currentLabel) {
                        topLabel.style.opacity = '1'
                        topLabel.innerText = currentLabel.innerText
                        // console.log("topLabel.innerText === ", topLabel.innerText)
                    } else {
                        topLabel.style.opacity = '0'
                    }
                    if (vm.scrollTimer != -1) {
                        clearTimeout(vm.scrollTimer);
                    }
                    vm.scrollTimer = setTimeout(vm.scrollFinished, 500);
                })
            },
            scrollFinished() {
                const topLabel = document.getElementById('date-label')
                topLabel.style.visibility = "hidden"
            },
            GetLastMessageList() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetLastMessageList",
                    params: {
                        ConversationId: vm.conversationId,
                        ReservationId: vm.reservationId && vm.reservationId != "null" ? vm.reservationId : vm.lastMessageObject.ReservationId ? vm.lastMessageObject.ReservationId : null
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("GetLastMessageList", err);
                            return;
                        }
                        if (response) {
                            console.log("GetLastMessageList res=", response)
                            vm.sendSourceOptionsList.splice(0)
                            if (response[1] && response[1].length > 0) {
                                vm.lastMessageObject = response[1][0]
                                vm.$emit("lastMessageObject_rq", vm.lastMessageObject)
                                // if (vm.lastMessageObject.IsUseremailexists) {
                                //     vm.sendSourceOptionsList.push({
                                //         SourceName: "Mail",
                                //         sourceId: 2
                                //     })
                                // }
                                // if (vm.lastMessageObject.IsPlatformemailexists) {
                                //     vm.sendSourceOptionsList.push({
                                //         SourceName: "Airbnb",
                                //         sourceId: 1
                                //     })
                                // }
                                if (response[1][0].SourceId) {
                                    vm.selectedSendSource = response[1][0].SourceId
                                }
                                if (response[1][0].MediumId) {
                                    vm.selectedMediumId = response[1][0].MediumId
                                }
                                // if (response[1][0].SourceId == 1) {
                                //     vm.selectedSendSource = 2
                                // } else if (response[1][0].SourceId == 5) {
                                //     vm.selectedSendSource = 1
                                // }
                                vm.previousConversationReplyStatus = vm.lastMessageObject.IsMessageReplied
                            }
                            vm.sendSourceOptionsList.splice(0, vm.sendSourceOptionsList.length, ...response[2])
                            for (let source of vm.sendSourceOptionsList) {
                                if ((source.SourceId == 1 && source.MediumId == 1) || source.MediumId == 3) {
                                    vm.$set(source, "Isexists", vm.lastMessageObject.IsUseremailexists)
                                } else if (source.MediumId == 1) {
                                    vm.$set(source, "Isexists", vm.lastMessageObject.IsPlatformemailexists)
                                } else if ((source.MediumId == 2 || source.MediumId == 4) && vm.lastMessageObject.PhoneNumber) {
                                    vm.$set(source, "Isexists", true)
                                }
                            }
                            vm.Get_LogDetails_By_ReservationId()
                        }
                    }
                })
            },
            defaultSourceClass() {
                let vm = this;
                let sourceObj = vm.sendSourceOptionsList.filter(source => source.SourceId == vm.selectedSendSource && source.MediumId == vm.selectedMediumId && source.Isexists)
                sourceObj = !sourceObj.length ? vm.sendSourceOptionsList.filter(source => source.SourceId == 1 && source.MediumId == 1 && source.Isexists) : sourceObj
                sourceObj = !sourceObj.length ? vm.sendSourceOptionsList.filter(source => source.Isexists) : sourceObj
                if (sourceObj.length) {
                    vm.selectedMediumId = sourceObj[0].MediumId
                    vm.selectedSendSource = sourceObj[0].SourceId
                    return sourceObj[0].SourceName
                }

            },
            scroll_bottom() {
                var container = $('.guest-chat-body'),
                    scrollTo = $('#unreadMessageTitle');
                if (scrollTo.length) {
                    // container.animate({
                    //     scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop() - 50
                    // });
                    $("#chat-body").scrollTop(scrollTo.offset().top - container.offset().top + container.scrollTop() - 50);
                } else {
                    $("#chat-body").scrollTop($('#chat-body')[0].scrollHeight);
                    $(".guest-chat-body").scrollTop($('.guest-chat-body')[0].scrollHeight);
                    // $(".guest-chat-body").stop().animate({ scrollTop: $(".guest-chat-body")[0].scrollHeight}, 1000);
                }
            },
            unreadMessagesIndicator(unreadMessage) {
                let result = ""
                if (!unreadMessage && !this.unreadMessageText) {
                    this.unreadMessageText = true
                    result += `<div class="chat-day-title">`
                    result += `<span class="title">`
                    result += 'Unread Message(s)';
                    result += `</span>`
                    result += `</div>`

                    return result
                } else {
                    return ""
                }
            },
            UpdateMessageStatus(conversationId) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "UpdateMessageStatus",
                    params: {
                        ConversationId: conversationId,
                        StatusId: 1
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("UpdateMessageStatus", err);
                            return;
                        }
                        if (response) {
                            console.log("response in UpdateMessageStatus", response);
                            if (vm.parentCallback) vm.parentCallback({ conversationId: conversationId });
                        }
                    }
                });
            },
            formatDateTime(date) {
                let vm = this;
                return moment(date).format('hh:mm A');
            },
            formatUTCDate(date) {
                let vm = this;
                return moment.utc(date).format("MMM DD");
            },
            redirectTOGuestProfile() {
                let vm = this;
                vm.$router.push("/guestProfileDetail/" + vm.guestInfo.guestProfileId);
            },
            getMeduimName(msg) {
                let vm = this
                let Medium = vm.sendSourceOptionsList.filter(source => source.MediumId == msg.MediumId && source.SourceId == msg.SourceId)
                if (Medium.length && msg.SourceName != 'Mail') {
                    // alert(JSON.stringify(Medium))
                    return Medium[0].MediumId == "1" && msg.SourceId == 1 ? 'Tempo' : Medium[0].SourceName
                }
                else {
                    return msg.SourceName
                }
            },
            sendReplyMail() {
                let vm = this;
                vm.elemHtml = vm.editor.getHTML()
                vm.templateDetail.HTMLObj = vm.elemHtml

                const tempElement = document.createElement('div');
                tempElement.innerHTML = vm.elemHtml;

                // Check if the element has no text content
                const hasNoTextContent = !tempElement.textContent.trim();

                if (hasNoTextContent) {
                    console.log('The input text has no text content.');
                    vm.elemHtml = vm.elemHtml.match(/<p[^>]*><\/p[^>]*>/g) ? vm.elemHtml.replace(/<p[^>]*><\/p[^>]*>/g, "") : ""
                } else {
                    console.log('The input text has text content.');
                }
                // vm.elemHtml = vm.elemHtml.match(/<p[^>]*><\/p[^>]*>/g) ? vm.elemHtml.replace(/<p[^>]*><\/p[^>]*>/g, "<br>") : vm.elemHtml
                // vm.templateDetail.HTMLObj = vm.messageToSend
                // vm.previewSlectedTemplate("send mail") 
                // vm.$nextTick(function () {
                setTimeout(function () {
                    let sourceList = vm.sendSourceOptionsList.filter(source => source.SourceId == vm.selectedSendSource && source.MediumId == vm.selectedMediumId)
                    console.log('testingSetTimoutFunction', (vm.messageToSendTextvals && vm.messageToSendTextvals != null) || vm.imageData.length > 0)
                    if ((vm.messageToSendTextvals && vm.messageToSendTextvals != null) || vm.imageData.length > 0) {
                        // let obj = vm.messages[vm.messages.length-1]
                        vm.sendShowHide = false;
                        let sendEmail
                        let isfromTagUI = false
                        if (vm.selectedSendSource == 1 && vm.selectedMediumId == 1) {
                            sendEmail = vm.lastMessageObject.UserEmail
                            isfromTagUI = false
                        }
                        else if (sourceList[0].SourceName == 'SMS' || sourceList[0].SourceName == 'WhatsApp') {
                            if ((!vm.phoneNumbers && !vm.phoneNumbers.length) || (!vm.lastMessageObject.PhoneNumber)) {
                                vm.$store.dispatch("toastr", {
                                    type: "warning",
                                    header: "Warning!",
                                    message: "Check the Phone numbers"
                                });
                                return
                            }
                            let sendMessage = vm.updateMessageToSend ? vm.updateMessageToSend : vm.docuSignMessageFromModal ? vm.docuSignMessageFromModal : vm.elemHtml
                            if (sendMessage.length > 160 && sourceList[0].SourceName != 'WhatsApp') {
                                vm.$store.dispatch("toastr", {
                                    type: "warning",
                                    header: "Maxmimum Character Limit!",
                                    message: `Please limit your message to 160 characters or less. Got ${sendMessage.length}`
                                });
                                return
                            }
                        }
                        else {
                            sendEmail = vm.lastMessageObject.ReplyToEmail
                            if (vm.selectedSendSource == 5) {
                                isfromTagUI = true
                            }
                        }

                        vm.$store.dispatch("dataRequestHandler", {
                            key: "sendReplyMail",
                            params: {
                                ClientName: vm.lastMessageObject.ClientName,
                                ConversationId: vm.conversationId,
                                MessageId: vm.lastMessageObject.MessageId,
                                ReservationId: vm.lastMessageObject.ReservationId,
                                GuestProfileId: vm.lastMessageObject.GuestProfileId,
                                PropertyId: null,
                                ConfirmationNumber: vm.lastMessageObject.ConfirmationNumber,
                                ReplyToEmail: vm.lastMessageObject.UserReplytoEmail,
                                ReplyToCode: "",
                                SourceName: sourceList[0].SourceId == 1 ? "Tempo" : sourceList[0].SourceName,
                                selectedSource: sourceList[0],
                                // Message: vm.updateMessageToSend ? vm.updateMessageToSend : vm.messageToSend,
                                Message: vm.updateMessageToSend ? vm.updateMessageToSend : vm.docuSignMessageFromModal ? vm.docuSignMessageFromModal : vm.elemHtml,
                                SourceXML: "",
                                UnitName: vm.lastMessageObject.UnitName,
                                ArrivalDate: vm.lastMessageObject.Arrivaldate,
                                DepartureDate: vm.lastMessageObject.Departuredate,
                                mailDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                                replyToName: "",//vm.lastMessageObject.GuestName,
                                mailName: vm.lastMessageObject.LoginUserName,
                                mailUserId: "",//vm.lastMessageObject.SourceUserId,
                                subject: vm.lastMessageObject.Subject && !vm.lastMessageObject.isReplyMessage ? vm.lastMessageObject.Subject : `Reservation at ${vm.lastMessageObject.UnitName} for ${moment.utc(vm.lastMessageObject.Arrivaldate).format("DD MMM YYYY")} - ${moment.utc(vm.lastMessageObject.Departuredate).format("DD MMM YYYY")}`,
                                toEmail: sendEmail,
                                FromMail: vm.lastMessageObject.FromMail,
                                MailService: vm.lastMessageObject.MailService,
                                Password: vm.lastMessageObject.Password,
                                fromTempo: true,
                                messageID: vm.lastMessageObject.SourceMessageId,
                                isfromTagUI: isfromTagUI,
                                guestName: vm.guestInfo.guestName,
                                GuestFirstName: vm.lastMessageObject.GuestFirstName,
                                GuestLastName: vm.lastMessageObject.GuestLastName,
                                threadId: vm.lastMessageObject.ThreadId,
                                lastMessageObject: vm.lastMessageObject,
                                imageDataArr: vm.imageData.length ? vm.imageData : vm.templateDetail.SendImage && vm.templateDetail.SendImage == 1 ? [{
                                    ImageUrl: vm.templateDetail.ImageUID,
                                    ImageId: -1
                                }] : vm.imageData,
                                apiUrl: vm.apiUrl,
                                templateId: vm.selectedTemplate,
                                phoneNumbers: vm.phoneNumbers
                            },
                            callback: function (err, response) {
                                if (err) {
                                    console.log("sendReplyMail", err);
                                    vm.sendShowHide = true
                                    return;
                                }
                                if (response) {
                                    console.log("response in sendReplyMail", response);
                                    vm.istemplateActive = false;
                                    vm.messageToSend = null
                                    vm.updateMessageToSend = null
                                    vm.elemHtml = null
                                    vm.selectedTemplateType = null
                                    vm.isDocuSignModalOpen = false
                                    vm.isDocuSignTemplate = false
                                    vm.docuSignMessageFromModal = null
                                    vm.selectedGuestEmails = []
                                    vm.guestNames = {}
                                    vm.guestRoles = {}
                                    vm.selectedGuests = []
                                    vm.selectedDocusignGuests = []
                                    vm.messageToSendTextvals = null
                                    // $(".editableDivMessage").text() = ""
                                    // document.getElementById('editableDivMessage').innerHTML = ""
                                    vm.sendShowHide = true
                                    vm.editor.setContent()
                                    vm.templateDetail = {}
                                    vm.conversationId = response[1][0].ConversationId
                                    vm.updateReplyStatus(response[1][0].MessageId)
                                    vm.imageData.splice(0)
                                    vm.$refs.fileupload.value = null;
                                    localStorage.removeItem("MessageInboxImage_" + vm.reservationId);
                                    localStorage.removeItem("MessageInbox_" + vm.reservationId);
                                }
                            }
                        });
                    }
                }, 300)
            },
            updateReplyStatus(repliedMessageId) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "updateReplyStatus",
                    params: {
                        ConversationId: vm.conversationId,
                        repliedMessageId: repliedMessageId
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("updateReplyStatus", err);
                            return;
                        }
                        if (response) {
                            console.log("response in updateReplyStatus", response);
                            vm.GetConversationMessageList(vm.conversationId)
                            setTimeout(() => {
                                if (vm.updateReplymessage) vm.updateReplymessage({
                                    conversationId: vm.conversationId,
                                    previousConversationId: vm.previousConversationId,
                                    IsMessageReplied: vm.lastMessageObject.IsMessageReplied,
                                    repliedUsersList: vm.repliedUsersList
                                });
                            }, 500);

                        }
                    }
                });
            },
            Get_TemplatesList() {
                let vm = this;
                vm.showTemplateList = !vm.showTemplateList
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_TemplatesList",
                    params: {
                        StatusId: 1,
                        SearchText: null
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("Get_TemplatesList", err);
                            return;
                        }
                        if (response) {
                            console.log("response in Get_TemplatesList", response);
                            // vm.templateList = response[0];
                            if (vm.matchedIntegration.IsIntegrated) {
                                vm.templateList = response[0];
                            } else if (!vm.matchedIntegration.IsIntegrated) {
                                vm.templateList = response[0].filter(item => item.TemplateTypeId !== "5");
                            }
                        }
                    }
                });
            },
            selectTemplate(template) {
                let vm = this;
                vm.currentStep = 1;
                vm.templateSearch = '';
                vm.selectedTemplate = template.TemplateId;
                vm.selectedTemplateType = template.TemplateTypeId;
                console.log('selectedTemplate', { selectedTemplate: vm.selectedTemplate, selectedTemplateType: vm.selectedTemplateType });
                vm.istemplateActive = true;
                switch (template.TemplateTypeId) {
                    case "1":
                        vm.selectedSendSource = vm.lastMessageObject.IsPlatformemailexists ? vm.lastMessageObject.SourceId : 1;
                        vm.selectedMediumId = vm.lastMessageObject.IsPlatformemailexists ? vm.lastMessageObject.MediumId  ? vm.lastMessageObject.MediumId : 1 : 1
                        break;
                    case "2":
                        vm.selectedSendSource = 1;
                        vm.selectedMediumId = 2
                        break;
                    case "4":
                        vm.selectedSendSource = 1;
                        vm.selectedMediumId = 4
                        break;
                    case "5":
                        vm.selectedSendSource = 1;
                        vm.selectedMediumId = 3;
                        console.log('newValueselectedMediumId======>Selectemplate', vm.sendShowHide);
                        localStorage.setItem('selectedTemplate', vm.selectedTemplate);
                        localStorage.setItem('selectedTemplateType', vm.selectedTemplateType);
                        break;

                    default:
                        break;
                }
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetTemplates_Details",
                    params: {
                        TemplateId: template.TemplateId
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("GetTemplates_Details", err);
                            return;
                        }
                        if (response) {
                            vm.currentStep = 1;
                            console.log("response in GetTemplates_Details", response);
                            vm.templateDetail = response[2][0];
                            if (vm.selectedTemplateType == '5' && (vm.templateDetail.CCHTML !== null && vm.templateDetail.CCHTML !== '')) {
                                vm.currentStep = 1;
                                vm.getDocuSignTemplateDetails();
                                vm.isDocuSignModalOpen = true;
                                vm.openDocuSignModal();
                                vm.isDocuSignTemplate = true;
                            }
                            if (vm.selectedTemplateType == '5') {
                                vm.currentStep = 1;
                                localStorage.setItem('clientId', vm.templateDetail.ClientId);
                            }
                            vm.previewSlectedTemplate();
                            vm.getGuestData();
                            vm.getSignersData();
                            vm.getCompanyData();
                        }
                    }
                });
            },
            closeDocuSignModal() {
                let vm = this;
                vm.selectedMediumId = null;
                vm.sendShowHide = false;
                vm.lastMessageObject.SendEmail = false;
                vm.messageToSendTextvals = false;
                vm.SignatoryRoleCustomTabs = [];
                if (vm.docusignEnvelopeId !== null) {
                    vm.DeleteDocusignEnvelope();
                }
                vm.isSendDisable = false;
                vm.isDocuSignModalOpen = false;
                vm.$emit('isDocuSignModalOpen', vm.isDocuSignModalOpen);
                vm.currentStep = 1;
                vm.selectedGuestEmails = [];
                vm.guestNames = {};
                vm.guestRoles = {};
                vm.selectedGuests = [];
                vm.selectedDocusignGuests = [];
                vm.docuSignMessageFromModal = null;
                clearTimeout(vm.setTime);
                vm.setTime = null;
                vm.url = null;
                vm.isDocusignIframe = false;
                vm.docusignEnvelopeId = null;
                // vm.isDocusignHref= null;
                vm.docuSignLoader = false;
                vm.editor.setContent();
                localStorage.removeItem('MessageInbox_' + window.location.href.split("/").pop());
                // if(vm.isDocuSignTemplate){
                //     vm.editor.setContent();
                // }
                vm.isDocuSignTemplate = false;
                vm.loading = false;
                vm.DocumentCustomTags = {};

            },
            filteredRoles(email) {
                // Get the roles already assigned to other emails

                const assignedRoles = Object.values(this.guestRoles)
                    .filter(role => role !== this.guestRoles[email])
                    .map(role => role.roleName);

                // Filter out the roles not already assigned
                const filteredRoles = {};
                for (const roleTypeName in this.docusignTemplateDetails.recipients) {
                    const roles = this.docusignTemplateDetails.recipients[roleTypeName].filter(role => !assignedRoles.includes(role.roleName));
                    if (roles.length > 0) {
                        filteredRoles[roleTypeName] = roles;
                    }
                }
                return filteredRoles;
            },
            customTagFilteredRoles(email) {
                // Get the roles already assigned to other emails
                // console.log('guestRoles======>', guestRoles);
                const assignedRoles = Object.values(this.guestRoles)
                    .filter(role => role !== this.guestRoles[email])
                    .map(role => role.roleName);

                // Filter out the roles not already assigned
                const customTagFilteredRoles = {};
                for (const roleTypeName in this.DocumentCustomTags.recipients) {
                    const roles = this.DocumentCustomTags.recipients[roleTypeName].filter(role => !assignedRoles.includes(role.roleName));
                    if (roles.length > 0) {
                        customTagFilteredRoles[roleTypeName] = roles;
                    }
                }
                this.SignatoryRoleCustomTabs = customTagFilteredRoles.signers;
                // console.log('customTagFilteredRoles========>', customTagFilteredRoles.signers)
                return customTagFilteredRoles;
            },
            openDocuSignModal() {
                let vm = this;
                if (vm.selectedMediumId === 3) {
                    vm.isDocuSignModalOpen = true;

                    this.$emit('isDocuSignModalOpen', this.isDocuSignModalOpen);
                    if (vm.lengthOfCustomTab === 0) {
                        vm.$store.dispatch("toastr", {
                            type: "warning",
                            message: "No Roles Provided for Signatory!",
                            header: "warning",
                        });
                    }
                    //     console.log('selectedRoleNames=============>', {DocumentCustomTags: vm.DocumentCustomTags,
                    // updatedCustomTabArray: vm.DocumentCustomTags,
                    // lengthOfCustomTab: vm.lengthOfCustomTab,
                    // SignatoryRoleCustomTabs: vm.SignatoryRoleCustomTabs});
                }
            },
            onIframeLoad() {
                let vm = this;
                window.addEventListener(
                    "message",
                    (event) => {
                        console.log("Checking Scheduled Data=======>", event.data.scheduleTime);
                        console.log("Checking Scheduled Data=======>", event.data);
                        if (event.data.href) {
                            console.log('iframe======>href', vm.isDocusignHref);
                            vm.setTime = setTimeout(() => {
                                vm.currentStep = 3;
                                vm.isDocusignHref = event.data.href;
                                console.log('test====>', vm.currentStep);
                                vm.isDocusignIframe = false;
                            }, 2000)
                        }
                    }
                );
            },
            CreateDocuSignDocument() {
                let vm = this;
                //vm.selectedDocusignGuests

                vm.selectedDocusignGuests = vm.selectedGuestEmails.map(email => {
                    const { recipientType, routingOrder, roleName } = vm.guestRoles[email] || { recipientType: null, routingOrder: null, roleName: null };
                    const formatedSignerName = (email) => {
                        const parts = email.split('@')[0].split('.');
                        return parts.map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' ');
                    };
                    return {
                        email: email,
                        name: vm.guestNames[email] || formatedSignerName(email),
                        role: { recipientType, routingOrder, roleName }
                    };
                });
                let selectedRoleNames = vm.selectedDocusignGuests.map(data => {
                    return data.role.roleName;
                })
                let isRoleNameIsNulls = selectedRoleNames.includes(null);
                console.log('selectedDocusignGuests============>', { templateDetails: vm.elemHtml ? vm.elemHtml : elemHtml, templateTypeId: vm.selectedTemplateType ? vm.selectedTemplateType : selectedTemplateType, selectedRoleNames, isRoleNameIsNulls: !isRoleNameIsNulls, isDocuSignTemplate: vm.isDocuSignTemplate });
                //console.log('vm.selectedGuestEmails==========>', vm.selectedGuestEmails, vm.lengthOfCustomTab, vm.selectedGuestEmails.length);
                if (vm.docuSignMessageFromModal && vm.selectedGuestEmails !== 0 && !isRoleNameIsNulls) {
                    vm.docuSignLoader = true;
                    // extracting the filename as got in html tags
                    // const tempElement = document.createElement("div");
                    // tempElement.innerHTML = vm.templateDetail.SubjectLineHTML;
                    // vm.extractedText = tempElement.textContent || tempElement.innerText;

                    const selectedTemplate = localStorage.getItem('selectedTemplate');
                    const selectedTemplateType = localStorage.getItem('selectedTemplateType');
                    const elemHtml = localStorage.getItem('elemHtml');
                    const clientId = localStorage.getItem('clientId');
                    vm.selectedGuests = vm.selectedGuestEmails.map(email => {
                        const { recipientType, routingOrder, roleName } = vm.guestRoles[email] || { recipientType: "", routingOrder: "", roleName: "" };
                        const formatedSignerName = (email) => {
                            const parts = email.split('@')[0].split('.');
                            return parts.map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' ');
                        };
                        return {
                            email: email,
                            name: vm.guestNames[email] || formatedSignerName(email),
                            role: { recipientType, routingOrder, roleName }
                        };
                    });
                    console.log('vm.selectedGuests', vm.selectedGuests);
                    vm.docuSignDocumentUuid = uuidv4();
                    vm.$store.dispatch("dataRequestHandler", {
                        key: "SendDocuSignDocument",
                        params: {
                            recipientDetails: vm.selectedGuests,
                            templateId: vm.selectedTemplate ? vm.selectedTemplate : selectedTemplate,
                            templateTypeId: vm.selectedTemplateType ? vm.selectedTemplateType : selectedTemplateType,
                            templateDetails: vm.elemHtml ? vm.elemHtml : elemHtml,
                            reservationId: vm.$route.params.ReservationId || vm.reservationId,
                            clientId: vm.templateDetail && vm.templateDetail.ClientId ? vm.templateDetail.ClientId : clientId,
                            unitId: vm.lastMessageObject.UnitId,
                            userId: 0,
                            propertyId: vm.roomInfo && vm.roomInfo.PropertyId ? vm.roomInfo.PropertyId : null,
                            message: vm.docuSignMessageFromModal,
                            fileName: vm.subjectLine ? vm.subjectLine.textvals : "DocuSign Document",
                            isDocuSignTemplate: vm.isDocuSignTemplate ? vm.isDocuSignTemplate : false,
                            templateTags: vm.isDocuSignTemplate ? vm.templateTags : null,
                            docuSignTemplateId: vm.isDocuSignTemplate ? vm.templateDetail.CCHTML : null,
                            docuSignDocumentUuid: vm.docuSignDocumentUuid
                        },
                        callback: function (err, response) {
                            if (err) {
                                console.log("err ==-=-=-=-=->::::::::", err);
                                // add invalid_grant err toaster also
                                if (err === 'consent_required') {
                                    console.log('err', err);
                                    vm.$store.dispatch("toastr", {
                                        type: "error",
                                        message: "The verification request sent to the email was not accepted",
                                        header: "Error",
                                    });
                                    vm.closeDocuSignModal();
                                } else if (err.error === 'invalid_grant') {
                                    vm.$store.dispatch("toastr", {
                                        type: "error",
                                        message: "The provided user ID is not activated.",
                                        header: "Error",
                                    });
                                    vm.closeDocuSignModal();
                                }
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    message: "Error while sending document",
                                    header: "Error",
                                });
                                vm.closeDocuSignModal();
                                return;
                            }
                            if (response) {
                                console.log("envelopeResponse=====>response===>", response);
                                vm.isDocusignIframe = true;
                                vm.docusignPreviwUrl = response.envelopeResponse.controlEnvelopeEditorView;
                                vm.docusignEnvelopeId = response.envelopeResponse.envelopeId;
                                if (vm.currentStep === 1) {

                                    vm.currentStep = 2;
                                }
                                // if(vm.docuSignMessageFromModal != null){
                                //     vm.sendReplyMail();
                                // }
                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    header: "Success!",
                                    message: "successfully Created Document"
                                });
                                vm.$store.dispatch("toastr", {
                                    type: "info",
                                    message: "NOTE: Please Allow the third party cookies in browser settings",
                                    header: "info!",
                                });
                                // vm.closeDocuSignModal();
                                // vm.selectedTemplateType = null;
                                // vm.isDocuSignModalOpen = false;
                                // vm.isDocuSignTemplate = false;
                                // vm.$emit('isDocuSignModalOpen', vm.isDocuSignModalOpen);
                                vm.docuSignLoader = false;


                                // // Remove items from localStorage
                                // localStorage.removeItem('selectedTemplate');
                                // localStorage.removeItem('selectedTemplateType');
                                // localStorage.removeItem('elemHtml');
                                // localStorage.removeItem('clientId');

                            }
                        }
                    });
                } else {
                    if (isRoleNameIsNulls || vm.SignatoryRoleCustomTabs !== undefined || (vm.lengthOfCustomTab !== vm.selectedGuestEmails.length)) {
                        vm.$store.dispatch("toastr", {
                            type: "warning",
                            header: "Warning",
                            message: "Please specify recepient Emails and Roles"
                        });
                    } else {

                        vm.$store.dispatch("toastr", {
                            type: "error",
                            header: "Error",
                            message: "All Fields are Mandatory"
                        });
                    }
                }
            },
            previousDocusignEnvelope() {
                let vm = this;
                if (vm.docuSignMessageFromModal && vm.selectedGuestEmails !== 0 && this.isDocusignHref) {
                    vm.docuSignLoader = true;

                    vm.docuSignDocumentUuid = uuidv4();
                    vm.$store.dispatch("dataRequestHandler", {
                        key: "SendOrGetPriviousDocuSignEnvelope",
                        params: {
                            clientId: vm.templateDetail && vm.templateDetail.ClientId ? vm.templateDetail.ClientId : clientId,
                            DocusignHref: vm.isDocusignHref,
                            docuSignDocumentUuid: vm.docuSignDocumentUuid,
                            previousEnvelope: true,
                        },
                        callback: function (err, response) {
                            if (err) {
                                console.log("err ==-=-=-=-=->::::::::", err);
                                // add invalid_grant err toaster also
                                if (err === 'consent_required') {
                                    console.log('err', err);
                                    vm.$store.dispatch("toastr", {
                                        type: "error",
                                        message: "The verification request sent to the email was not accepted",
                                        header: "Error",
                                    });
                                    vm.closeDocuSignModal();
                                } else if (err.error === 'invalid_grant') {
                                    vm.$store.dispatch("toastr", {
                                        type: "error",
                                        message: "The provided user ID is not activated.",
                                        header: "Error",
                                    });
                                    vm.closeDocuSignModal();
                                }
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    message: "Error while sending document",
                                    header: "Error",
                                });
                                vm.closeDocuSignModal();
                                return;
                            }
                            if (response) {
                                vm.isDocusignIframe = true;
                                vm.docuSignLoader = false;
                                vm.docusignPreviwUrl = response.PreviousEnvelopeUrl;
                                vm.currentStep = 2;

                            }
                        }
                    });
                } else {
                    vm.$store.dispatch("toastr", {
                        type: "error",
                        header: "Error",
                        message: "All Fields are Mandatory"
                    });
                    vm.docuSignLoader = false;
                }
            },
            SendDocusignEnvelope() {
                let vm = this;
                vm.isSendDisable = true;
                if (vm.docuSignMessageFromModal && vm.selectedGuestEmails !== 0) {

                    vm.docuSignLoader = true;

                    vm.docuSignDocumentUuid = uuidv4();
                    vm.$store.dispatch("dataRequestHandler", {
                        key: "SendOrGetPriviousDocuSignEnvelope",
                        params: {
                            clientId: vm.templateDetail && vm.templateDetail.ClientId ? vm.templateDetail.ClientId : clientId,
                            DocusignHref: vm.isDocusignHref,
                            docuSignDocumentUuid: vm.docuSignDocumentUuid,
                            previousEnvelope: false,
                        },
                        callback: function (err, response) {
                            if (err) {
                                console.log("err ==-=-=-=-=->::::::::", err);
                                // add invalid_grant err toaster also
                                if (err === 'consent_required') {
                                    console.log('err', err);
                                    vm.$store.dispatch("toastr", {
                                        type: "error",
                                        message: "The verification request sent to the email was not accepted",
                                        header: "Error",
                                    });
                                    vm.closeDocuSignModal();
                                } else if (err.error === 'invalid_grant') {
                                    vm.$store.dispatch("toastr", {
                                        type: "error",
                                        message: "The provided user ID is not activated.",
                                        header: "Error",
                                    });
                                    vm.closeDocuSignModal();
                                }
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    message: "Error while sending document",
                                    header: "Error",
                                });
                                vm.closeDocuSignModal();
                                return;
                            }
                            if (response) {
                                if (vm.docuSignMessageFromModal != null) {
                                    vm.sendReplyMail();
                                }

                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    header: "Success!",
                                    message: "successfully Sent Document"
                                });
                                clearTimeout(vm.setTime);
                                vm.setTime = null;
                                vm.docusignPreviwUrl = null;
                                vm.isDocusignIframe = false;
                                vm.isDocusignHref = null;
                                vm.docusignEnvelopeId = null;
                                // vm.closeDocuSignModal();
                                vm.selectedTemplateType = null;
                                vm.isDocuSignModalOpen = false;
                                vm.isDocuSignTemplate = false
                                vm.currentStep = 1;
                                vm.$emit('isDocuSignModalOpen', vm.isDocuSignModalOpen);
                                vm.docuSignLoader = false;

                                // Remove items from localStorage
                                localStorage.removeItem('selectedTemplate');
                                localStorage.removeItem('selectedTemplateType');
                                localStorage.removeItem('elemHtml');
                                localStorage.removeItem('clientId');

                            }
                        }
                    });
                } else {
                    vm.$store.dispatch("toastr", {
                        type: "error",
                        header: "Error",
                        message: "All Fields are Mandatory"
                    });
                }
            },
            DeleteDocusignEnvelope() {
                let vm = this;
                if (vm.docuSignMessageFromModal && vm.selectedGuestEmails !== 0) {
                    vm.docuSignLoader = true;

                    // vm.docuSignDocumentUuid = uuidv4();
                    vm.$store.dispatch("dataRequestHandler", {
                        key: "DeleteDocusignEnvelope",
                        params: {
                            clientId: vm.templateDetail && vm.templateDetail.ClientId ? vm.templateDetail.ClientId : clientId,
                            docusignEnvelopeId: vm.docusignEnvelopeId,
                            // docuSignDocumentUuid: vm.docuSignDocumentUuid,
                            // previousEnvelope: false,
                        },
                        callback: function (err, response) {
                            if (err) {
                                console.log("err ==-=-=-=-=->::::::::", err);
                                // add invalid_grant err toaster also
                                if (err === 'consent_required') {
                                    console.log('err', err);
                                    vm.$store.dispatch("toastr", {
                                        type: "error",
                                        message: "The verification request sent to the email was not accepted",
                                        header: "Error",
                                    });
                                    vm.closeDocuSignModal();
                                } else if (err.error === 'invalid_grant') {
                                    vm.$store.dispatch("toastr", {
                                        type: "error",
                                        message: "The provided user ID is not activated.",
                                        header: "Error",
                                    });
                                    vm.closeDocuSignModal();
                                }
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    message: "Error while Deleting document",
                                    header: "Error",
                                });
                                vm.closeDocuSignModal();
                                return;
                            }
                            if (response) {
                                vm.docusignEnvelopeId = null;
                                console.log('DeleteEnvelopeSuccessfully====>', response);
                                vm.$store.dispatch("toastr", {
                                    type: "info",
                                    header: "Success!",
                                    message: `${response.status}`
                                });
                                vm.isDocusignHref = null;
                                clearTimeout(vm.setTime);
                                vm.setTime = null;
                                vm.docusignPreviwUrl = null;
                                vm.isDocusignIframe = false;
                                // vm.isDocusignHref= null;
                                // vm.docusignEnvelopeId = null;
                                // vm.closeDocuSignModal();
                                vm.selectedTemplateType = null;
                                vm.isDocuSignModalOpen = false;
                                vm.isDocuSignTemplate = false
                                vm.currentStep = 1;
                                vm.$emit('isDocuSignModalOpen', vm.isDocuSignModalOpen);
                                vm.docuSignLoader = false;

                                // Remove items from localStorage
                                localStorage.removeItem('selectedTemplate');
                                localStorage.removeItem('selectedTemplateType');
                                localStorage.removeItem('elemHtml');
                                localStorage.removeItem('clientId');

                            }
                        }
                    });
                } else {
                    vm.$store.dispatch("toastr", {
                        type: "error",
                        header: "Error",
                        message: "All Fields are Mandatory"
                    });
                }
            },
            getDocuSignTemplateDetails() {
                let vm = this;
                const res_clientId = localStorage.getItem('clientId');
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetDocuSignTemplateDetails",
                    params: {
                        templateId: vm.templateDetail.CCHTML ? vm.templateDetail.CCHTML : "",
                        clientId: vm.templateDetail && vm.templateDetail.ClientId ? vm.templateDetail.ClientId : res_clientId,
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("err in GetDocuSignTemplateDetails ==-=-=-=-=->::::::::", err);

                            return;
                        }
                        if (response) {
                            console.log("response for GetDocuSignTemplateDetails ==-=-=-=-=->::::::::", response);
                            vm.docusignTemplateDetails = response.docusignTemplateDetails;
                            console.log('vm.docusignTemplateDetails', vm.docusignTemplateDetails);
                            localStorage.removeItem('clientId');

                        }
                    }
                });
            },
            getSignersData() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetUsersByClientIdAndEntityName",
                    params: {
                        clientId: vm.templateDetail && vm.templateDetail.ClientId ? vm.templateDetail.ClientId : clientId,
                        entityName: "Sign"
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("err", err);
                            return;
                        }
                        if (response) {
                            vm.signersList = response[0].map(function (item) {
                                return item.Email;
                            });
                        }
                    }
                });
            },
            getGuestData() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetReservationDetailById",
                    params: {
                        ModuleAction: "GetReservationDetailById",
                        ReservationId: vm.$route.params.ReservationId || vm.reservationId,
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("err", err);
                            return;
                        }
                        if (response) {
                            console.log("response ==-=-=-=-=->::::::::", response);
                            vm.res_guestProfileId = response.guestInfo.GuestProfileId;
                            vm.res_companyProfileId = response.guestInfo.CompanyProfileId;
                            vm.getCompanyData();
                            vm.guestEmailList = response.additionalEmails.map(function (item) {
                                return item.Emailaddress;
                            });
                        }
                    }
                });
            },
            getCompanyData() {
                let vm = this;
                vm.loading = true;
                console.log('vm.res_companyProfileId', vm.res_companyProfileId);
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_GuestProfile_Detail",
                    params: {
                        ModuleAction: "Get_GuestProfile_Detail",
                        GuestProfileId: vm.res_companyProfileId,
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("err", err);
                            return;
                        }
                        if (response) {
                            vm.loading = false;
                            // vm.companyEmailList = response[5].map(function(item) {
                            //     return item.Emailaddress;
                            // });
                            vm.companyEmailList = response[5].map(item => item.Emailaddress !== undefined ? item.Emailaddress : null).filter(email => email !== null);
                        }
                    }
                });
            },
            addImageToTemplate(command) {
                const src = prompt('Insert the image URL')
                if (src !== null) {
                    command({ src })
                }
            },
            Get_ListOfIntegrations() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_ListOfIntegrations",
                    params: {
                        ModuleAction: "Get_ListOfIntegrations"
                    },
                    callback: function (err, response) {
                        if (err) {
                            return;
                        } else {
                            vm.matchedIntegration = response[0].find(function (item) {
                                return item.IntegrationId === 12;
                            });
                        }
                    }
                });
            },
            previewSlectedTemplate(fromMethod, templateDetail, scheduleBot) {
                let vm = this;
                vm.currentStep = 1;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "getPreviewSlectedTemplate",
                    params: {
                        //elemHtml
                        templateDetail: fromMethod == 'fromScheduleBots' ? templateDetail : vm.templateDetail,
                        ReservationId: vm.lastMessageObject.ReservationId
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("getPreviewSlectedTemplate", err);
                            return;
                        }
                        if (response) {
                            vm.templateTags = response.guestDetails.recordsets[10][0] // using for template tags data
                            console.log("response in getPreviewSlectedTemplate", response);
                            vm.subjectLine = response.subjectHtmlConstruct
                            if (fromMethod == 'fromScheduleBots') {
                                scheduleBot.scheduleBotMessage = response.htmlConstruct.resmsg
                                scheduleBot.scheduleBotObj.scheduleBotMessage = response.htmlConstruct.resmsg
                                console.log("scheduleBot.scheduleBotMessage = ", scheduleBot.scheduleBotMessage)
                            } else {
                                vm.messageToSendTextvals = response.htmlConstruct.textvals.trim()
                                vm.messageToSend = response.htmlConstruct.resmsg.trim()
                                // console.log('SendDocusignDocumentOnUPDATE=====>test', response.htmlConstruct.textvals);
                                vm.sendShowHide = true;
                                vm.lastMessageObject.SendEmail = true;
                                vm.messageToSendTextvals = true;
                                if (response.htmlConstruct.textvals) {
                                    vm.elemHtml = vm.editor.getHTML()
                                    console.log("prev-vm.elemHtmlprev----", vm.elemHtml);
                                    // vm.DocumentCustomTags = response.htmlConstruct.DocumentCustomTabArray;
                                    vm.DocumentCustomTags = {
                                        recipients: {
                                            signers: response.htmlConstruct.DocumentCustomTabArray
                                        }
                                    }
                                    vm.lengthOfCustomTab = response.htmlConstruct.lengthOfCustomTab;
                                    //    if (vm.elemHtml === '<p></p>') vm.elemHtml = ''
                                    // vm.elemHtml = vm.elemHtml.match(/<p[^>]*><\/p[^>]*>/g) ? vm.elemHtml.replace(/<p[^>]*><\/p[^>]*>/g, "<br>") : vm.elemHtml
                                    // vm.elemHtml= vm.elemHtml.match(/<p[^>]*>(?:\s|&nbsp;)*<\/p>/g) ? vm.elemHtml.replace(/<p[^>]*>(?:\s|&nbsp;)*<\/p>/g, "") : vm.elemHtml

                                    vm.$emit('input', vm.elemHtml)
                                    vm.elemHtml += vm.messageToSend
                                    if (vm.selectedTemplateType == '5') {
                                        localStorage.setItem('elemHtml', vm.elemHtml);
                                    }
                                    vm.editor.setContent(vm.elemHtml);
                                    vm.sendShowHide = true;
                                    vm.lastMessageObject.SendEmail = true;
                                    vm.messageToSendTextvals = true;

                                    // vm.initEditor();

                                    localStorage.setItem("MessageInbox_" + vm.reservationId, vm.editor.getHTML());
                                    console.log("vm.messageToSend--", vm.messageToSend, vm.messageToSendTextvals)

                                    // vm.editor.setContent(vm.messageToSend)
                                } else {
                                    vm.editor.setContent()
                                    vm.sendShowHide = false;
                                    vm.lastMessageObject.SendEmail = false;
                                    vm.messageToSendTextvals = false;
                                }
                                if (!fromMethod && !response.htmlConstruct.textvals && vm.selectedTemplateType != '5' && (vm.templateDetail.CCHTML !== null || vm.templateDetail.CCHTML !== '')) {
                                    vm.$store.dispatch("toastr", {
                                        type: "warning",
                                        header: "Warning!",
                                        message: "No template Detail"
                                    });
                                    vm.editor.setContent()
                                    vm.sendShowHide = false;
                                    vm.lastMessageObject.SendEmail = false;
                                    vm.messageToSendTextvals = false;
                                }
                            }
                        }
                    }
                });
            },
            // updateCustomRoleName(response) {
            //     let vm = this;

            //     // Parse the response string into a DOM object using DOMParser
            //     const parser = new DOMParser();
            //     const doc = parser.parseFromString(response, 'text/html');

            //     // Log the parsed HTML structure (optional)
            //     console.log('Parsed HTML================>', doc);

            //     // Select all <strong> elements from the parsed HTML
            //     const strongTags = doc.querySelectorAll('strong');

            //     // Loop through each <strong> tag
            //     strongTags.forEach((strongTag) => {
            //         let roleName = strongTag.innerHTML; // Get the inner HTML of the <strong> tag

            //         // Check if the roleName starts with "@"
            //         if (roleName.startsWith("@")) {
            //             console.log('Role name starts with @================>', roleName);

            //             // Add the roleName to the vm.updatedCustomTabArray (or perform your logic)
            //             vm.updatedCustomTabArray.push({ recipientType: "signer", roleName: roleName });

            //             console.log("Role name starts with @================>Updated custom tab array================>", vm.updatedCustomTabArray);
            //         }
            //     });

            //     // If you need to convert the updated HTML back to a string
            //     const updatedHTML = doc.body.innerHTML;
            //     console.log('Updated HTML================>', updatedHTML);

            //     return updatedHTML; // Return if needed
            // },

            getMessageFormatedDataContent(message, imgeurl) {
                message = message.replace(/(?<!\S)<p><\/p>/g, '');
                if (imgeurl) {
                    message += `<img src=${this.apiUrl}/downloadImage/${imgeurl}/null height="200">`
                }
                return message.replace(/<p><\/p>/g, '<br>');
            },
            updateHTML: function (e) {
                let vm = this;
                vm.updateMessageToSend = e.target.innerHTML
                console.log("vm.updateMessageToSend == ", vm.updateMessageToSend)
                // this.$emit(vm.messageToSend, e.target.innerHTML);
            },
            initEditor() {
                let vm = this;
                if (vm.editor) {
                    vm.editor.destroy()
                }
                this.editor = new Editor({
                    extensions: [
                        new Placeholder(),
                        new Blockquote(),
                        new CodeBlock(),
                        new HardBreak(),
                        new Heading({ levels: [1, 2, 3] }),
                        new BulletList(),
                        new OrderedList(),
                        new ListItem(),
                        new TodoItem(),
                        new TodoList(),
                        new Bold(),
                        new Code(),
                        new Italic(),
                        new Link(),
                        new Strike(),
                        new Underline(),
                        new History(),
                        new HorizontalRule(),
                        new Table({
                            resizable: true,
                        }),
                        new TableCell(),
                        new TableHeader(),
                        new TableRow(),
                        new Image(),
                        new Mention({
                            // matcher: {
                            //   char: '^',
                            // },
                            // a list of all suggested items
                            items: () => [],
                            // is called when a suggestion starts
                            onEnter: ({
                                items, query, range, command, virtualNode,
                            }) => {
                                vm.query = query
                                vm.filteredUsers = items
                                vm.suggestionRange = range
                                vm.renderPopup(virtualNode)
                                // console.log('vm.renderPopup(virtualNode)=====>', virtualNode)
                                // we save the command for inserting a selected mention
                                // this allows us to call it inside of our custom popup
                                // via keyboard navigation and on click
                                vm.insertMention = command
                            },
                            // is called when a suggestion has changed
                            onChange: ({
                                items, query, range, virtualNode,
                            }) => {
                                vm.query = query
                                vm.filteredUsers = items
                                vm.suggestionRange = range
                                vm.navigatedUserIndex = 0
                                vm.renderPopup(virtualNode)
                            },
                            // is called when a suggestion is cancelled
                            onExit: () => {
                                // reset all saved values
                                vm.query = null
                                vm.filteredUsers = []
                                vm.suggestionRange = null
                                vm.navigatedUserIndex = 0
                                vm.destroyPopup()
                            },
                            onKeyDown: ({ event }) => {
                                // pressing up arrow
                                if (event.keyCode === 38) {
                                    vm.upHandler()
                                    return true
                                }
                                // pressing down arrow
                                if (event.keyCode === 40) {
                                    vm.downHandler()
                                    return true
                                }
                                // pressing enter
                                if (event.keyCode === 13) {
                                    vm.enterHandler()
                                    return true
                                }
                                return false
                            },
                            // is called when a suggestion has changed
                            // this function is optional because there is basic filtering built-in
                            // you can overwrite it if you prefer your own filtering
                            // in this example we use fuse.js with support for fuzzy search
                            onFilter: (items, query) => {
                                if (!query) {
                                    return items
                                }
                                const fuse = new Fuse(items, {
                                    threshold: 0.2,
                                    keys: ['label'],
                                })
                                return fuse.search(query)
                            },
                        }),
                    ],
                    onUpdate: ({ getJSON, getHTML, state, transaction }) => {
                        // vm.updateCustomRoleName(getHTML());
                        // vm.templateDetail.JSONObj = getJSON()
                        // vm.templateDetail.HTMLObj = getHTML()
                        vm.messageToSend = getHTML()
                        // vm.templateDetail.HTMLObj = getHTML()                      
                        vm.elemHtml = getHTML()
                        vm.messageToSendTextvals = vm.editor.state.doc.textContent.trim()
                        // console.log("editor.statet======>", {vmElement: vm.elemHtml, HtmlObject:vm.templateDetail.HTMLObj});
                        console.log('SendDocusignDocumentOnUPDATE=====>', vm.editor.state.doc.textContent);
                        if (vm.editor) {
                            let textContent = vm.editor.state.doc.textContent;
                            if (textContent != "") {
                                localStorage.setItem("MessageInbox_" + vm.reservationId, vm.editor.getHTML());
                                vm.sendShowHide = true;
                                vm.lastMessageObject.SendEmail = true;
                                vm.messageToSendTextvals = true;
                            } else {
                                localStorage.removeItem("MessageInbox_" + vm.reservationId);
                                vm.sendShowHide = false;
                                vm.lastMessageObject.SendEmail = false;
                                vm.messageToSendTextvals = false;
                            }
                        }
                    },
                    // content: vm.entityNotificationTemplate.templateHtml,
                }),
                    vm.editor.setContent()
                console.log("editor.state.doc.textContent", vm.editor.state.doc.textContent)
                // if (vm.templateDetail && vm.templateDetail.HTMLObj) {
                //     vm.editor.setContent(vm.templateDetail.HTMLObj)
                // }
            },
            disableIfNoAddress() {
                let vm = this;
                let sendSourceOptionsList = vm.sendSourceOptionsList.filter(source => source.SourceId == vm.selectedSendSource && source.MediumId == vm.selectedMediumId && !source.Isexists)
                if (sendSourceOptionsList.length > 0) {
                    return true
                } else {
                    return false
                }

            },
            drop: function (event) {
                let vm = this;
                event.preventDefault();
                console.log("vm.selectedParamvm.selectedParam", vm.selectedParam)
                var span = document.createElement("span");
                var node = document.createTextNode(vm.selectedParam.label);
                span.appendChild(node);
                span.setAttribute("class", "mention");
                span.setAttribute("data-mention-id", vm.selectedParam.id);
                event.target.appendChild(span);
            },
            allowDrop: function (event) {
                event.preventDefault();
            },
            getRefs() {
                let vm = this;
                console.log("getRefs = ", this.$refs)
                for (let key of Object.keys(vm.groupedMessagesList)) {
                    for (let msg of vm.groupedMessagesList[key].messages) {
                        let refval = `contentheight${msg.indexval}`
                        // console.log(Object.keys(this.$refs), refval)
                        msg.contentheight = this.$refs[`contentheight${msg.indexval}`] && this.$refs[`contentheight${msg.indexval}`][0] ? this.$refs[`contentheight${msg.indexval}`][0].offsetHeight : 0
                    }
                }
            },
            checkTempoOrDocusignTemplate() {
                vm = this;
                if (vm.isDocuSignTemplate) {
                    return Object.keys(vm.guestRoles).length === 0;
                }
            },
            prevStep() {
                let vm = this;
                if (vm.currentStep === 3 && vm.isDocusignHref) {
                    vm.docuSignLoader = true;
                    // vm.currentStep = 2;
                    // vm.docuSignLoader = true;
                    setTimeout(() => {
                        vm.previousDocusignEnvelope();
                    }, 500)
                }
                else if (vm.currentStep === 2) {
                    vm.currentStep = 1;
                    vm.isDocusignHref = null;
                    vm.docuSignLoader = false;

                }
            },
            nextStep() {
                let vm = this;
                if (vm.currentStep === 1) {
                    vm.CreateDocuSignDocument();
                }
            }
        },
        updated: function () {
            let vm = this;
            // vm.editor.setContent();
            // vm.nextTick(() => {
            vm.footerHeightString = $('.ProseMirror').height()
            console.log('vm.editor=======>Check', (!vm.editor.state.doc.textContent && vm.selectedMediumId === null));
            if (!vm.editor.state.doc.textContent && vm.selectedMediumId === null) {
                vm.selectedMediumId = 1;
            }
            // });
            // console.log('updated, clientHeight =', this.height); // seems ok
        },

        computed: {
            newConversation() {
                return this.$store.getters.getConversation;
            },
            getRefreshMessageNotificationPanelStatus() {
                return this.$store.getters.getRefreshMessageNotificationPanel();
            },
            //for template filter in message inbox detail
            filteredTemplates() {

                return this.templateList.filter(template =>
                    template.TemplateName.toLowerCase().includes(this.templateSearch.toLowerCase())
                );
            },
            progressWidth() {
                return ((this.currentStep - 1) / (this.steps.length - 1)) * 100;
            }
        },
        created() {
            let vm = this;
            vm.$store.state.bus.$on("getNoficicationConversation", function (dataobj) {
                vm.reservationId = dataobj.ReservationId
                vm.GetConversationMessageList(dataobj.ConversationId);
            });
        },
        watch: {
            // selectedMediumId(newValue, oldValue) {
            //     setTimeout(()=>{
            //         if(newValue === null){
            //             this.selectedMediumId = 1;
            //         }
            //         console.log('newValueselectedMediumId======>', newValue, oldValue);
            //     }, 2000);
            // },
            // selectTemplate(newValue, oldValue) {
            //     if (newValue == "<p></p>") {
            //         this.istemplateActive = false;
            //     }
            // },
            elemHtml(newValue, oldValue) {
                if (newValue == "<p></p>") {
                    this.istemplateActive = false;
                }
            },
            // sendShowHide(newValue, oldValue) {
            //     console.log('newValueselectedMediumId======>', newValue, oldValue);
            // },
            reservationId: {
                handler: function (reservationId, oldResId) {
                    this.reservationId = reservationId
                    this.GetConversationMessageList(this.conversationId);
                }
            },
            conversationId: {
                handler: function (conversationId, oldVal) {
                    console.log("oldVal = ", oldVal)
                    this.previousConversationId = oldVal
                    // if (conversationId) {
                    this.GetConversationMessageList(conversationId);
                    // this.imageData.splice(0);
                    // this.$refs.fileupload.value = null;
                    // this.initEditor()
                    setTimeout(function () {
                        this.$refs.fileupload.value = null;
                        let messageContent = localStorage.getItem("MessageInbox_" + this.reservationId);
                        if (this.editor) {
                            if (messageContent != null && messageContent != '') {
                                this.editor.setContent(messageContent);
                                this.sendShowHide = true;
                                this.lastMessageObject.SendEmail = true;
                                this.messageToSendTextvals = true;
                            } else {
                                this.editor.setContent();
                                localStorage.removeItem("MessageInbox_" + this.reservationId);
                                this.sendShowHide = false;
                                this.lastMessageObject.SendEmail = false;
                                this.messageToSendTextvals = false;
                            }
                        }
                        let imagesList = localStorage.getItem("MessageInboxImage_" + this.reservationId);
                        this.imageData = imagesList == undefined ? [] : JSON.parse(imagesList);
                        if (this.imageData.length > 0) {
                            localStorage.setItem("MessageInboxImage_" + this.reservationId, JSON.stringify(this.imageData));
                            this.sendShowHide = true;
                            this.lastMessageObject.SendEmail = true;
                            this.messageToSendTextvals = true;
                        } else {
                            localStorage.removeItem("MessageInboxImage_" + this.reservationId);
                            if (messageContent == null || messageContent == "") {
                                this.sendShowHide = false;
                                this.lastMessageObject.SendEmail = false;
                                this.messageToSendTextvals = false;
                            }
                        }
                    }.bind(this), 10);
                    // if (this.editor) {
                    //     this.editor.setContent()
                    // }
                    this.messageToSend = ""
                    // }
                },
                deep: true,
                immediate: true
            },
            messageFilterType: {
                handler: function (messageFilterType, oldVal) {
                    this.previousMessageFilterType = oldVal
                },
                deep: true
            },
            footerHeightString: {
                handler: function (newHeight, oldHeight) {
                    console.log("newHeight", newHeight, "=", oldHeight)
                    if (newHeight == 38) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 307px)" });
                        $(".guest-chat-info").css({ "margin-top": "-38px" });
                        // $(".chat-box.resdetail-chat-box .guest-chat .guest-chat-body").css({ "height":" calc(100vh - 228px)" });
                    }
                    else if (newHeight == 38.5) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 307px)" });
                        $(".guest-chat-info").css({ "margin-top": "-38px" });
                        // $(".chat-box.resdetail-chat-box .guest-chat .guest-chat-body").css({ "height":" calc(100vh - 228px)" });
                    }
                    else if (newHeight == 76) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 345px)" });
                        $(".guest-chat-info").css({ "margin-top": "-76px" });
                    }
                    else if (newHeight == 77) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 345px)" });
                        $(".guest-chat-info").css({ "margin-top": "-76px" });
                    }
                    else if (newHeight == 108) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 345px)" });
                        $(".guest-chat-info").css({ "margin-top": "-114px" });
                    }
                    else if (newHeight == 114) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 382px)" });
                        $(".guest-chat-info").css({ "margin-top": "-114px" });
                    }
                    else if (newHeight == 115.5) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 382px)" });
                        $(".guest-chat-info").css({ "margin-top": "-114px" });
                    }
                    else if (newHeight == 152) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 420px)" });
                        $(".guest-chat-info").css({ "margin-top": "-152px" });
                    }
                    else if (newHeight == 154) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 420px)" });
                        $(".guest-chat-info").css({ "margin-top": "-152px" });
                    }
                    else if (newHeight == 190) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 459px)" });
                        $(".guest-chat-info").css({ "margin-top": "-190px" });
                    }
                    else if (newHeight == 192.5) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 459px)" });
                        $(".guest-chat-info").css({ "margin-top": "-190px" });
                    }
                    else if (newHeight == 228) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 496px)" });
                        $(".guest-chat-info").css({ "margin-top": "-228px" });
                    }
                    else if (newHeight == 231) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 496px)" });
                        $(".guest-chat-info").css({ "margin-top": "-228px" });
                    }
                    else if (newHeight == 253) {
                        $(".guest-chat-body").css({ "height": " calc(100vh - 522px)" });
                        $(".guest-chat-info").css({ "margin-top": "-253px" });
                    }
                    // if (newHeight && oldHeight && newHeight > oldHeight) {
                    //     // alert("height up")
                    //     $(".guest-chat-body").css({ "height": `${$(".guest-chat-body").height() - 20}` });
                    // } else if (newHeight && oldHeight && newHeight < oldHeight) {
                    //     // alert("height down")
                    //     $(".guest-chat-body").css({ "height": `${$(".guest-chat-body").height() + 40}` });
                    // }
                },
                deep: true
            },
            messageToSend: {
                handler: function (newHeight, oldHeight) {
                    this.footerHeightString = $('.ProseMirror').height()
                },
                deep: true
            },
            getRefreshMessageNotificationPanelStatus(oldVal, newVal) {
                console.log(this.getRefreshMessageNotificationPanelStatus);
                console.log("this.newConversation.conversationObj = ", this.newConversation.conversationObj)
                console.log("this.getRefreshMessageNotificationPanelStatus && this.newConversation.conversationObj &&(this.conversationId == this.newConversation.conversationObj.ConversationId || this.reservationId == this.newConversation.conversationObj.EventGeneratedId) == ", this.getRefreshMessageNotificationPanelStatus && this.newConversation.conversationObj && (this.conversationId == this.newConversation.conversationObj.ConversationId || this.reservationId == this.newConversation.conversationObj.EventGeneratedId))
                if (this.getRefreshMessageNotificationPanelStatus && this.newConversation.conversationObj && (this.conversationId == this.newConversation.conversationObj.ConversationId || this.reservationId == this.newConversation.conversationObj.EventGeneratedId)) {
                    this.GetConversationMessageList(this.conversationId);
                }
            }
            // previousConversationId: {
            //     handler: function (conversationId, oldVal) {
            //         if (conversationId && conversationId != oldVal) {
            //             this.UpdateMessageStatus(conversationId);
            //         }
            //     },
            //     deep: true
            // }
        },
        mounted() {
            // console.log("messageInboxDetail", document.querySelector(".guest-chat-body").scrollHeight);
            // setTimeout(function () {
            //     $("#chat-body").scrollTop($('#chat-body')[0].scrollHeight);
            //     $(".guest-chat-body").scrollTop($('.guest-chat-body')[0].scrollHeight);
            // }, 500);
            let vm = this;
            vm.Get_ListOfIntegrations();
            vm.initEditor();
            if (this.editor) {
                let messageContent = localStorage.getItem("MessageInbox_" + vm.reservationId);
                if (messageContent != null && messageContent != '') {
                    this.editor.setContent(messageContent);
                    this.sendShowHide = true;
                    this.lastMessageObject.SendEmail = true;
                    this.messageToSendTextvals = true;
                } else {
                    this.editor.setContent();
                    localStorage.removeItem("MessageInbox_" + vm.reservationId);
                    this.sendShowHide = false;
                    this.lastMessageObject.SendEmail = false;
                    this.messageToSendTextvals = false;
                }
            }
            if (vm.conversationId) {
                // vm.GetConversationMessageList();
            }
            $(document).click(function (e) {
                // alert("hai")
                vm.showTemplateList = false;
                vm.templateSearch = '';
                console.log('vm.templateSearch', vm.templateSearch);
                // vm.showBotslist = false
                console.log("this.showTemplateList", vm.showTemplateList)
            })
            $(document).ready(function () {
                $('[data-toggle="tooltip"]').tooltip();
            });
        }
    };
</script>
<style>
    /* .date {
        text-align: center;
        color: red;
    } */
    .divider {
        text-align: center;
    }

    .divider span {
        display: inline-block;
        padding: 6px 12px;
        text-align: center;
        line-height: 1;
        background: gray;
        color: #fff;
        border-radius: 6px;
    }

    .sticky {
        position: relative;
    }

    .sticky span {
        position: fixed;
        top: 135px;
        width: auto;
    }

    .ProseMirror p.is-empty:first-child::before {
        content: "Write a message";
        float: left;
        color: #adb5bd;
        pointer-events: none;
        height: 0;
    }

    .infoContainer {
        z-index: 0 !important;
    }

    .docuSignMessageInput {
        width: 100%;
        padding: 10px;
        height: 15vh;
        border: 1px solid rgba(0, 0, 0, 0.22);
        color: #868686;
        border-radius: 3px;
    }

    .docuSignMessageInput:focus-visible {
        border-color: #80bdff;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }

    .docuSignMessageInput_heading {
        font-size: 14px;
        color: #868686;
        font-weight: 400;
        margin-bottom: 2px;
    }

    .docuSignEmails {
        /* margin-top: 6px;  */
        margin-left: 10px;
        font-size: 14px;
        min-width: 230px;
        max-width: 230px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .docuSignEmails_label {
        margin-top: 14px;
        color: #868686;
    }

    .docuSign_labels_emails {
        display: flex;
    }

    .loading_spinner {
        font-size: 24px;
        margin-left: 10px
    }

    .email_guests_docuSign {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }

    .guestName_docuSign:focus-visible {
        border-color: #80bdff;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }

    .template_search {
        position: sticky;
        top: -15px;
        background-color: white !important;
    }

    .template_search .fa.fa-search {
        position: absolute;
        z-index: 1;
        left: 23px;
        top: 9px;
        opacity: .3;
    }

    .no_templates_matched:hover {
        background-color: white !important;
    }

    .chat-box .guest-chat .guest-chat-footer .form-control:focus {
        border-bottom: 1px solid #ccc;
    }

    /* ==========stepper styles=============== */
    .stepper-container {
        position: relative;
        width: 70%;
    }

    .stepper-progress-bar {
        position: absolute;
        top: 13px;
        left: 0;
        width: 100%;
        height: 3px;
        background-color: white;
        z-index: 1;
    }

    .stepper-progress {
        height: 3px;
        background-color: #FFC100;
        z-index: 2;
    }

    .stepper {
        display: flex;
        justify-content: space-between;
        position: relative;
        z-index: 3;
    }

    .step-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        /* width: 0%; */

        width: 0%;
        background-color: #4D70E0;
    }

    .step {
        padding: 8px;
        border-radius: 50%;
        background-color: white;
        width: 25px;
        height: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 3;
        font-weight: 500;
        color: black;
    }

    .step.active {
        background-color: #FFC100;
        color: black;
    }

    .step-label {
        text-align: center;
        color: white;
        font-weight: 400;
    }

    .step_content {
        display: none;
    }

    .step_content.active {
        display: block;
    }

    .step-button {
        padding: 10px 20px;
        cursor: pointer;
    }

    .step-button:disabled {
        cursor: not-allowed;
        background-color: lightgray;
    }
</style>